import React, { useCallback } from 'react';
import { Drawer, Container, Grid, AppBar, Tabs, Tab } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { IoIosCloseCircleOutline } from 'react-icons/io';

import TabPanel from '../../../../../Configuracoes/TabBar/TabPanel';

import Detalhes from './tabs/Detalhes';
import Tamanhos from './tabs/Tamanhos';
import Complementos from './tabs/Complementos';
import Disponibilidade from './tabs/Disponibilidade';

import { useProdutoPizza } from '../../../../../../hooks/produtoPizza';

import { AddProductButton } from '../../../styles';
import { CloseButton, DrawerContainer, DrawerTitle } from '../../drawer_styles';

interface NewProdutoPizzaProps {
  grupo_id: number;
}

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

const NewProdutoPizza: React.FC<NewProdutoPizzaProps> = ({ grupo_id }) => {
  const classes = useStyles();

  const {
    produtoId,
    drawerIsOpen,
    currentTabIndex,
    tamanhosIsEnabled,
    complementosIsEnabled,
    disponibilidadeIsEnabled,
    openDrawer,
    resetDrawer,
    changeCurrentTabIndex,
    changeProdutoPizzaData,
  } = useProdutoPizza();

  const handleOpenDrawer = useCallback(() => {
    changeProdutoPizzaData({
      grupo_id,
    });
    openDrawer();
  }, [grupo_id, openDrawer, changeProdutoPizzaData]);

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
    >
      <AddProductButton type="button" onClick={handleOpenDrawer}>
        + Adicionar Produto
      </AddProductButton>

      <Drawer
        anchor="right"
        open={drawerIsOpen && !produtoId}
        onClose={resetDrawer}
      >
        <CloseButton onClick={resetDrawer} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Novo Produto</h1>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={currentTabIndex}
                    onChange={(event, value) => changeCurrentTabIndex(value)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product_tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} style={{ fontSize: '14px' }} />
                    <Tab
                      label="Tamanhos"
                      {...a11yProps(1)}
                      disabled={!tamanhosIsEnabled}
                      style={{ fontSize: '14px' }}
                    />
                    <Tab
                      label="Complementos"
                      {...a11yProps(2)}
                      disabled={!complementosIsEnabled}
                      style={{ fontSize: '14px' }}
                    />
                    <Tab
                      label="Disponibilidade"
                      {...a11yProps(3)}
                      disabled={!disponibilidadeIsEnabled}
                      style={{ fontSize: '14px' }}
                    />
                  </Tabs>
                </AppBar>

                <TabPanel value={currentTabIndex} index={0}>
                  <Detalhes />
                </TabPanel>
                <TabPanel
                  value={currentTabIndex}
                  index={1}
                  containerStyle={{ padding: 0 }}
                >
                  <Tamanhos />
                </TabPanel>
                <TabPanel value={currentTabIndex} index={2}>
                  <Complementos grupo_id={grupo_id} />
                </TabPanel>
                <TabPanel value={currentTabIndex} index={3}>
                  <Disponibilidade />
                </TabPanel>
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </div>
  );
};

export default NewProdutoPizza;
